import { BulkUploadType } from './mediaConfig';

import { Platform } from '@/features/pages';

export const MB = 1024 * 1024;

/** Limits for sending content materials to chat — per platform and media type. */
export const PLATFORM_MEDIA_SIZE_LIMITS: Record<Platform, Record<BulkUploadType, number>> = {
  telegram: {
    photo: 10 * MB,
    video: 75 * MB,
    document: 50 * MB,
    audio: 20 * MB,
  },
  instagram: {
    photo: 8 * MB,
    video: 24 * MB,
    document: 25 * MB,
    audio: 8 * MB,
  },
};

export function getMaxMediaSizeBytes(platform: Platform, mediaType: BulkUploadType): number {
  return PLATFORM_MEDIA_SIZE_LIMITS[platform][mediaType];
}

export function getMaxMediaSizeMb(platform: Platform, mediaType: BulkUploadType): number {
  return Math.round(getMaxMediaSizeBytes(platform, mediaType) / MB);
}

export function formatMaxMediaSizeLabel(platform: Platform, mediaType: BulkUploadType): string {
  return `до ${getMaxMediaSizeMb(platform, mediaType)} МБ`;
}
